<template>
	<div class="cell small-12 medium-8 large-8">
		<PageLoading v-if="loading" />
		<div class="ProfileEdit_view__edit" v-if="loading == false">
			<Accordion
				v-on:toggle="
					() => {
						this.userInfoShow = !this.userInfoShow
					}
				"
				:title="$t('edit.userInformation')"
				v-bind:show="this.userInfoShow"
				:lightTheme="true"
			>
				<Profile_Form />
			</Accordion>

			<Accordion
				v-on:toggle="
					() => {
						this.userPassShow = !this.userPassShow
					}
				"
				:title="$t('login.passwordPlaceholder')"
				v-bind:show="this.userPassShow"
				:lightTheme="true"
			>
				<Settings_Form />
			</Accordion>

			<Accordion
				v-on:toggle="
					() => {
						this.userConsentShow = !this.userConsentShow
					}
				"
				:title="$t('edit.consentTitle')"
				v-bind:show="this.userConsentShow"
				:lightTheme="true"
			>
				<Consent_Form />
			</Accordion>
		</div>
		<div v-html="$t('edit.removeAccountText')"></div>
	</div>
</template>

<script>
import PageLoading from '../../components/atoms/PageLoading'
import Accordion from '../../components/molecules/Accordion.vue'
import Profile_Form from '../../components/organisms/forms/Profile_Form'
import Settings_Form from '../../components/organisms/forms/Settings_Form'
import Consent_Form from '../../components/organisms/forms/Consent_Form'
import store from '../../vueX/store'

export default {
	name: 'ProfileEdit_view',
	store,
	components: {
		PageLoading,
		Accordion,
		Profile_Form,
		Settings_Form,
		Consent_Form
	},
	data() {
		return {
			user: store.state.user.id,
			bookings: [],
			loading: false,
			userInfoShow: false,
			userPassShow: false,
			userConsentShow: false
		}
	},
	methods: {
		logout() {
			store.dispatch('REFRESH_TOKEN_BEFORE_REQUEST').then(() => {
				store
					.dispatch('DELETE_TOKEN', { token: store.state.token.refreshToken })
					.then(() => {
						this.$router.push({ name: 'login' })
					})
			})
		}
	},
	created: function () {
		this.loading = true

		store.dispatch('REFRESH_TOKEN_BEFORE_REQUEST').then(response => {
			if (response) {
				store.dispatch('GET_BOOKINGS', store.state.user.id).then(success => {
					if (success) {
						this.bookings = success.reverse()
						this.loading = false
					} else {
						this.loading = false
						// Error message
					}
				})
			} else {
				this.loading = false
			}
		})
	}
}
</script>

<style lang="scss">
.ProfileEdit_view {
	@include profile-background;
	h3 {
		margin-top: 40px;
	}
}
</style>
